import { getCurriedUpdateItemByPath } from 'shared/helpers/common';
import { CellChange } from 'shared/types/models/ExportFactAMP';

const updateItemByPath = getCurriedUpdateItemByPath<CellChange, number>();
export const updateRowInChange = updateItemByPath(['coordinate', 'row']);
